import Splide from '@splidejs/splide';
import { sponsoredStaySuggestion_click_log, start_campPage_log, stop_campPage_log } from './log';
import { disp_campReviews } from './util/review_scripts';
import { send_getPotentialDupes,send_reportDupeCamps,send_reportPermClosed,send_reportNotCampground,send_reportTempClosed,send_reportNewLocation,send_reportBadData } from './util/campReportScripts';
import { addMarker_googleMap, initMap_googleMaps } from './tripPlanner/tripPlanner_util/tripPlanner_g_map_util';
import { uploadCampPhotos } from './util/upload-image';

if (window.location.pathname.includes("rv-campgrounds") && window.location.pathname.split("/").length == 5 && window.location.pathname.split("/")[4] != '') {
  /*
   * window.location.pathname.split("/").length == 5 --
   *  to make this only run when at /rv-campgrounds/<state>/<city>/<camp_name>
   *  and not any of the browse pages
   */

  //////
  // sponsored camp listeners
  if (window.location.search.includes("spsid")) {
    let sponsoredEventId:string|null = new URLSearchParams(window.location.search).get("spsid");
    let externalCampPageLink:JQuery<HTMLElement> = $("[campgroundUrl]");
    let reserveBtn:JQuery<HTMLElement> = $("[campReserveBtn]");
    let instantBookBtn:JQuery<HTMLElement> = $("#cgCardInstantBookButton");
    externalCampPageLink.on("click", ()=>{sponsoredStaySuggestion_click_log(sponsoredEventId, campID, "websiteLink")});
    reserveBtn.on("click", ()=>{sponsoredStaySuggestion_click_log(sponsoredEventId, campID, "reserveLink")});
    instantBookBtn.on("click", ()=>{sponsoredStaySuggestion_click_log(sponsoredEventId, campID, "instantBook")});
  };
  //////

  $('.ai-cross[data-bs-dismiss="modal"]').css("opacity", "0");

  let campID:number = parseInt($(".campID").attr("id"));
  start_campPage_log(campID);

  if (document.getElementById("campPhotoCaro") != null) {
    new Splide(document.getElementById("campPhotoCaro") as HTMLElement).mount();

    var popup_main = new Splide(document.getElementById("photoSlidesPop_mainSplide") as HTMLElement);
    var popup_thumbnails = new Splide(document.getElementById("photoSlidesPop_thumbnailsSplide") as HTMLElement);
    popup_main.sync(popup_thumbnails);
    popup_main.mount();
    popup_thumbnails.mount();

    $("#photoSlidesPop").on("shown.bs.modal", () => {
      popup_main.emit("resize");
      popup_thumbnails.emit("resize");
    });
  };
  if (document.getElementById("campPhotoCaro2") != null) {
    new Splide(document.getElementById("campPhotoCaro2") as HTMLElement).mount();

    var popup_main = new Splide(document.getElementById("photoSlidesPop_mainSplide") as HTMLElement);
    var popup_thumbnails = new Splide(document.getElementById("photoSlidesPop_thumbnailsSplide") as HTMLElement);
    popup_main.sync(popup_thumbnails);
    popup_main.mount();
    popup_thumbnails.mount();

    $("#photoSlidesPop").on("shown.bs.modal", () => {
      popup_main.emit("resize");
      popup_thumbnails.emit("resize");
    });
  };
  disp_campReviews(campID);

  $(document).ready(function(){
    let coordsEl:JQuery<HTMLElement> = $("#coords");
    let lat:number = parseFloat(coordsEl.find("#lat").html());
    let lon:number = parseFloat(coordsEl.find("#lon").html());

    initMap_googleMaps("g-campPageMap", "hybrid", lat, lon, 15).then(map => {
      addMarker_googleMap(map, lat, lon);
    });
  });

} else {
  stop_campPage_log();
};

//Commented this out as I'm switching this buttons path from the modal to a new page
// $(document).on("click", "#campReportTypeBtn", function(event: Event) {
//   event.preventDefault();

//   if (window.location.pathname.includes("/campgrounds") || window.location.pathname.includes("/tripPlanner")) {
//     if ($(".modal-backdrop").length > 0) {
//       $(".modal-backdrop").remove();
//     };
//   };

//   $("#reportCampWrapper").html($("#campReportTypeModal").html())
//   $("#reportCampWrapper").modal("show");
// });

$(document).on("click", "#campReportTypeBtn_anon", function(event: Event) {
  event.preventDefault();

  if (window.location.pathname.includes("/campgrounds") || window.location.pathname.includes("/tripPlanner") || window.location.pathname.includes("/tripPlanner")) {
    if ($(".modal-backdrop").length > 0) {
      $(".modal-backdrop").remove();
    };
  };

  $("#reportCampWrapper").html($("#campReport_anon").html())
  $("#reportCampWrapper").modal("show");
});

$(document).on("click","#reportClosedDupeBtn", function(event: Event) {
  event.preventDefault();

  if (window.location.pathname.includes("/campgrounds") || window.location.pathname.includes("/tripPlanner") || window.location.pathname.includes("/tripPlanner")) {
    if ($(".modal-backdrop").length > 0) {
      $(".modal-backdrop").not(":first").remove();
    };
  };

  $("#reportCampWrapper").html($("#campReportClosedDupeModal").html());
  $("#reportCampWrapper").modal("show");
});

$(document).on("click","#reportTempClosedModalBtn", function(event:Event) {
  event.preventDefault();
  if ($(".modal-backdrop").filter(":visible").length > 1) {
    $(".modal-backdrop").not(":first").remove();
  };
  $("#reportCampWrapper").html($("#reportTempClosedModal").html());
  $("#reportCampWrapper").modal("show");
});

$(document).on("click","#campReportBadDataButton", function(event:Event) {
  event.preventDefault();

  if (window.location.pathname.includes("/campgrounds") || window.location.pathname.includes("/tripPlanner") || window.location.pathname.includes("/tripPlanner")) {
    if ($(".modal-backdrop").length > 0) {
      $(".modal-backdrop").not(":first").remove();
    };
  };

  $("#reportCampWrapper").html($("#campReportBadData").html());
  $("#reportCampWrapper").modal("show");
});

$(document).on("click","#campReportNewLocationBtn", function(event:Event) {
  event.preventDefault();
  $("#reportCampWrapper").html($("#campReportNewLocationModal").html());
});


//Get potential dupes (within 5 miles) by levenshtein distance of camp name
$(document).on("click","#reportDupeBtn", function() {
  let campID:string = $(this).attr("campID")
  let camp_name:string = $(this).attr("camp_name");
  let camp_lat:string = $(this).attr("camp_lat");
  let camp_lon:string = $(this).attr("camp_lon");

  $("#reportCampWrapper").modal();

  send_getPotentialDupes(campID,camp_name,camp_lat,camp_lon).then((response) => {
    $("#campReportClosedDupeModal").modal("hide");
    $("#reportCampWrapper").html(response);
    $("#reportCampWrapper").modal("show");
  }).catch(e => {
    const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
    $("#errorModal").modal("show");
  });
});

//Handle duplicate select submission and render "thank you for report" modal
$(document).on("submit", "#selectDupeForm", function(event:Event) {

  //prevent page reload on form submission
  event.preventDefault()

  let selectedEl:JQuery<HTMLElement> = $("input[name='potential_dupe']:checked");
  let dupe_campID:string = selectedEl.attr("dupe_campID").toString();
  let correct_campID:string = selectedEl.val().toString();

  $("#reportCampWrapper").modal("hide");

  send_reportDupeCamps(dupe_campID,correct_campID,false).then((response) => {
    $("#campReportThanks").modal("show");
  }).catch(e => {
    const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
    $("#errorModal").modal("show");
  });

});

//If we could not find a potential duplicate, allow user to enter camp name
$(document).on("submit", "#inputDupeForm", function(event:Event) {

  //prevent page reload on form submission
  event.preventDefault();

  let selectedEl:JQuery<HTMLElement> = $("#dupe_name");
  if (selectedEl.attr("dupe_campID")) {
    let dupe_campID:string = selectedEl.attr("dupe_campID").toString();
    let correct_name:string = selectedEl.val().toString();

    $("#reportCampWrapper").modal("hide");

    send_reportDupeCamps(dupe_campID,correct_name,true).then((response) => {
      $("#campReportThanks").modal("show");
    }).catch(e => {
      const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
      $("#errorModal").modal("show");
    });
  };
});

//Report permanently closed
$(document).on("click", "#reportPermClosed", function() {
  let campID:string = $(this).attr("campID").toString();

  $("#campReportClosedDupeModal").modal("hide");

  send_reportPermClosed(campID).then((response) => {
    $("#campReportThanks").modal("show");
  }).catch(e => {
    const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
    $("#errorModal").modal("show");
  });
});

//Make sure user inputted date is in MM/DD/YYYY format before reporting

$(document).on("input",$("#reportCampWrapper").find("#reopenDate"),function() {
  if ($("#reportCampWrapper").find("#reopenDate").length) {
    const regex = /^\d{2}\/\d{2}\/\d{4}$/;
    let isValidDate:boolean = regex.test($("#reportCampWrapper").find("#reopenDate").val().toString());
    let noInput:boolean = (!($("#reportCampWrapper").find("#reopenDate").val().toString().length))
    $("#reportCampWrapper").find("#submitTempClosedBtn").prop("disabled",(!(isValidDate || noInput)));
  }
});

//Report campgrounds is temporarily closed, with (optional) re-open date
$(document).on("submit", "#submitTempClosed", function(event:Event) {
  event.preventDefault();

  let dateEl:JQuery<HTMLElement> = $("#reopenDate");
  let reopenDate:string|undefined;
  let campID:string = dateEl.attr("campID");

  if (dateEl.val()) {
    reopenDate = dateEl.val().toString();
  } else {
    reopenDate = undefined;
  };

  $("#reportTempClosedModal").modal("hide");

  send_reportTempClosed(campID,reopenDate).then((response) => {
    $("#campReportThanks").modal("show");
  }).catch(e => {
    const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
    $("#errorModal").modal("show");
  });
});

//Report a new location for this Campground
$(document).on("submit","#reportNewLocation", function (event:Event) {

  //prevent page reload on form submission
  event.preventDefault();
  let newLocData: Record<string,string> = {"campID":$(this).attr("campID")};

  //get new location data from user input
  $(".data-form-input").each(function(this){
    if ($(this).prop("type") == "checkbox") return;
    if($(this).val() != $(this).attr("current_value")){
      newLocData[$(this).attr("id").toString()] = $(this).val().toString();
    };
  });

  $("#campReportNewLocationModal").modal("hide");

  send_reportNewLocation(newLocData).then((response) => {
    $("#campReportThanks").modal("show");
  }).catch(e => {
    const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
    $("#errorModal").modal("show");
  });

});

//Report that this campground is not a campground
$(document).on("click", "#reportNotCampground", function(event:Event) {
  let campID:string = $(this).attr("campID").toString();
  event.preventDefault();

  $("#campReportClosedDupeModal").modal("hide");

  send_reportNotCampground(campID).then((response) => {
    $("#campReportThanks").modal("show");
  }).catch(e => {
    const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
    $("#errorModal").modal("show");
  });
});

//Handle submission of incorrect data form
$(document).on("submit","#reportBadData", function(event:Event) {

  //prevent page reload on form submission
  event.preventDefault();
  let campID:string = $(this).attr("campID").toString();
  let newCampData: Record<string,string> = {"campID":campID};
  let newFeatures: Record<string,string[]> = {};
  let remFeatures: Record<string,string[]> = {};

  $("#campReportBadData").modal("hide");

  $(".data-form-input").each(function(this) {
    //only care about data that has been changed, added, or removed
    if ($(this).prop("type") == "checkbox") {
      //User said this campground has an amenity that our DB says it does not
      if ($(this).prop("checked") && $(this).attr("current_value").toString() == "0") {
        //append this feature to list of new features (for amenities, activities, etc.), or create that list if it is undefined
        if (newFeatures[$(this).attr("feature_type")] == undefined) {
          newFeatures[$(this).attr("feature_type")] = [$(this).attr("id")];
        } else {
          newFeatures[$(this).attr("feature_type")].push($(this).attr("id"));
        };

      //User said this campground does not have an amenity that our DB says it does
      } else if ((!($(this).prop("checked"))) && $(this).attr("current_value").toString() == "1") {
        if (remFeatures[$(this).attr("feature_type")] == undefined) {
          remFeatures[$(this).attr("feature_type")] = [$(this).attr("id")];
        } else {
          remFeatures[$(this).attr("feature_type")].push($(this).attr("id"));
        };
      };
    } else if (($(this).val().toString().length > 0 || $(this).attr("current_value").toString().length > 0) && ($(this).val() != $(this).attr("current_value"))) {
      newCampData[$(this).attr("id").toString()] = $(this).val().toString();
    };
  });

  send_reportBadData(newCampData,newFeatures,remFeatures).then((response)=> {
    $("#campReportThanks").modal("show");
  }).catch(e => {
    const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
    $("#errorModal").modal("show");
  });
});

//hide all modals when user clicks off of form ('x' or "Close")
$(document).on("click",".feedbackCloseBtn", function() {
  console.log("clicked feedback close btn")
  $(".modal").each(function(this) {
    $(this).modal("hide");
  });

  $(".modal-backdrop").remove();
});

$(document).on("input", ".data-form-input", function() {

  //Find the form and submit button for this input element
  let formEl:JQuery<HTMLElement> = $(this).parent().closest("form");
  let submitBtn:JQuery<HTMLElement> = formEl.find("button[type='submit']");
  let allSame:boolean = true;
  //Check if anything has changed
  $(".data-form-input").each(function(this){
    //need to handle check boxes differently than text/number inputs
    if ($(this).prop("type") == "checkbox") {
      //User said this campground has an amenity that our DB says it does not
      if ($(this).prop("checked") && $(this).attr("current_value").toString() == "0") {

        submitBtn.prop("disabled",false);
        allSame = false;
        return false;
      //User said this campground does not have an amenity that our DB says it does
      } else if ((!($(this).prop("checked"))) && $(this).attr("current_value").toString() == "1") {
        submitBtn.prop("disabled",false);
        allSame = false;
        return false;
      };
    //ensure valid format of date inputs
    } else if (($(this).attr("id") == "open_date") || ($(this).attr("id") == "close_date")) {
      const regex = /^\d{2}\/\d{2}\/\d{4}$/;
      submitBtn.prop("disabled",!(regex.test($(this).val().toString())));
    //ensure valid format of phone number input
    } else if (($(this).attr("id") === "info_phone") || ($(this).attr("id") === "reserve_phone")){
      const regex = /^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/;
      allSame = false;
      submitBtn.prop("disabled",!(regex.test($(this).val().toString())));
    } else if ($(this).prop("type") == "select") {
    //Handle text or number inputs
    } else if (($(this).val().toString().length > 0 || $(this).attr("current_value").toString().length > 0) && ($(this).val().toString() != $(this).attr("current_value").toString())) {
      submitBtn.prop("disabled",false);
      allSame = false;
      return false;
    };
  });
  if(allSame) submitBtn.prop("disabled", true);
});

$(document).on("change","#upload_camp_photo", (event: { target: HTMLInputElement; }) => {
  let selectedFiles:FileList = (event.target as HTMLInputElement).files as FileList;
  let newPhotos:Array<File> = Array.from(selectedFiles);
  const MAX_FILE_SIZE_BYTES = 30 * 1024 * 1024;

  if (newPhotos.length > 0) {
    $("#addedImages").html('');
    let fileNames:Array<string> = [];
    for (let i:number = 0; i < newPhotos.length; i++) {
      if (newPhotos[i].size > MAX_FILE_SIZE_BYTES) {
        alert('File size exceeds 30MB. Please choose a smaller file.');
        $(this).val('');
        return;
      }
      const reader = new FileReader();
      reader.onload = function(e) {
        if (e.target?.result) {
          const img = $('<img>').attr('src',e.target.result as string);
          $("#addedImages").append(img);
        }
      };

      reader.readAsDataURL(newPhotos[i]);
      fileNames.push(newPhotos[i].name);
    }
    $("#imgFileName").text(fileNames.join(', '));
    $("#confirmUpload").prop("disabled",false);
  } else {
    $("#imgFileName").text("No file selected");
    $("#confirmUpload").prop("disabled",true);
  }
});

$("#confirmUpload").on("click",function () {
  const fileInput = $('#upload_camp_photo')[0] as HTMLInputElement;
  const selectedFiles = fileInput.files;

  const confBtn = $(this);
  confBtn.prop("disabled",true);

  //get campID from ?campID={campID} in url with urlParams.get("campID");
  let campID:string = new URLSearchParams(window.location.search).get("campID")?.toString();
  if(campID == null){
    campID = undefined;
    const campName = $("#camp_name").val().toString();
    uploadCampPhotos(selectedFiles,campID,campName).then((response) => {
      //reset modal
      $("#addedImages").html('');
      $("#upload_camp_photo").val('');
      $("#imgFileName").text("No file selected");
      $("#confirmUpload").prop("disabled",true);

      $("#campReportAddImageModal").modal("hide");
      //$("#campReportThanks").modal("show");
    }).catch((e) => {
      const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
      $("#errorModal").modal("show");
      confBtn.prop("disabled", false);
    });
  }else{
    //let campID:string = $('#upload_camp_photo').attr("campID")?.toString();
    uploadCampPhotos(selectedFiles,campID,undefined).then((response) => {
      //reset modal
      $("#addedImages").html('');
      $("#upload_camp_photo").val('');
      $("#imgFileName").text("No file selected");
      $("#confirmUpload").prop("disabled",true);

      $("#campReportAddImageModal").modal("hide");
      //$("#campReportThanks").modal("show");
    }).catch((e) => {
      confBtn.prop("disabled", false);
      const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
      $("#errorModal").modal("show");
    });
  }
});

$("#campReportAddImageModal").on('hidden.bs.modal',function() {
  $("#upload_camp_photo").val('');
  $("#addedImages").html('');
  $("#imgFileName").text("No file selected");
  $("#confirmUpload").prop("disabled",true);
});

setTimeout(function() {
  wisepops("event", "enjoying-ag-trigger");
},10000);